import { render, staticRenderFns } from "./NationalityAge.vue?vue&type=template&id=b12c6a96&scoped=true&"
import script from "./NationalityAge.vue?vue&type=script&lang=js&"
export * from "./NationalityAge.vue?vue&type=script&lang=js&"
import style0 from "./NationalityAge.vue?vue&type=style&index=0&id=b12c6a96&scoped=true&lang=scss&"
import style1 from "./NationalityAge.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12c6a96",
  null
  
)

export default component.exports